const ListRefundType = () => import('./ListRefundType.vue')
const NewRefundType = () => import('./NewRefundType.vue')
const EditRefundType = () => import('./EditRefundType.vue')
const TheContainer = () => import('@/containers/TheContainer')

export default [
    {
        path: '/admin/refund-types',
        name: 'refundType',
        component: TheContainer,
        meta: {perms: ['admin.refund_type.list']},
        children: [
            {
                path: '',
                name: 'refundType.list',
                component: ListRefundType,
                meta: {label: 'Refund Types'},
            },
            {
                path: 'new',
                name: 'refundType.new',
                component: NewRefundType,
                meta: {label: 'Create Refund Type'},
            },
            {
                path: ':id',
                name: 'refundType.edit',
                component: EditRefundType,
                meta: {label: 'Edit Refund Type'},
            },
        ]
    }
]
